import React, { createContext, useState, useEffect, useCallback } from 'react';

export const CartContext = createContext();

const CartProvider = ({ children }) => {
  const [cartState, setCartState] = useState(() => {
    const savedCartState = localStorage.getItem('cartState');
    return savedCartState ? JSON.parse(savedCartState) : { cartItems: [], total: 0, menuChoices: {} };
  });

  useEffect(() => {
    localStorage.setItem('cartState', JSON.stringify(cartState));
  }, [cartState]);

  const addToCart = (item) => {
    let newCartItems;
    const uniqueId = Date.now() + Math.random(); // Génère un identifiant unique

    if (item.options && item.options.all) {
      // Pour les menus de type CartMenuPicker
      newCartItems = [...cartState.cartItems, { ...item, uniqueId }];
    } else if (item.options) {
      // Pour les menus de type CartMenuItem
      newCartItems = [...cartState.cartItems, { ...item, uniqueId }];
    } else {
      // Pour les articles simples
      const existingItem = cartState.cartItems.find(cartItem => cartItem.id === item.id && cartItem.nom === item.nom);
      if (existingItem) {
        newCartItems = cartState.cartItems.map(cartItem =>
          cartItem.id === item.id && cartItem.nom === item.nom ? { ...cartItem, quantity: cartItem.quantity + 1 } : cartItem
        );
      } else {
        newCartItems = [...cartState.cartItems, { ...item, quantity: 1 }];
      }
    }

    const newTotal = cartState.total + item.prix;
    setCartState({ ...cartState, cartItems: newCartItems, total: newTotal });
  };

  const removeFromCart = (item) => {
    let newCartItems;
    if (item.options && item.options.all) {
      newCartItems = cartState.cartItems.filter(cartItem => cartItem.uniqueId !== item.uniqueId);
    } else {
      const existingItem = cartState.cartItems.find(cartItem => cartItem.id === item.id && cartItem.nom === item.nom);
      if (existingItem.quantity > 1) {
        newCartItems = cartState.cartItems.map(cartItem =>
          cartItem.id === item.id && cartItem.nom === item.nom ? { ...cartItem, quantity: cartItem.quantity - 1 } : cartItem
        );
      } else {
        newCartItems = cartState.cartItems.filter(cartItem => cartItem.id !== item.id || cartItem.nom !== item.nom);
      }
    }
    const newTotal = cartState.total - item.prix;
    setCartState({ ...cartState, cartItems: newCartItems, total: newTotal });
  };

  const updateMenuChoice = useCallback((uniqueId, choice) => {
    const newMenuChoices = { ...cartState.menuChoices, [uniqueId]: { ...choice, isValid: choice.isValid } };
    setCartState({ ...cartState, menuChoices: newMenuChoices });
  }, [cartState]);

  const clearCart = () => {
    setCartState({ cartItems: [], total: 0, menuChoices: {} });
    localStorage.removeItem('cartState');
  };

  return (
    <CartContext.Provider value={{ ...cartState, addToCart, removeFromCart, updateMenuChoice, clearCart }}>
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
